import { AxiosPromise } from 'axios';
import { IGetResumes } from '../models/employeesResume.model';
import axios from 'axios';

const uri = '/mgmt/employees/resume';

export const getResumes = (memberId: string): AxiosPromise<IGetResumes> => {
  return axios.get(`${uri}/${memberId}`);
}

export const createResume = (memberId: string, data: any): AxiosPromise => {
  return axios.post(`${uri}/${memberId}`, data);
};

export const deleteResume = (resumeId: string): AxiosPromise => {
  return axios.delete(`${uri}/${resumeId}`);
};
